export enum EnrolmentStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ENLISTED = 'ENLISTED',
}
